/**
 * ActionPreview component
 *
 * Shows preview of an action (like saving a person) with confirm/cancel buttons.
 */

import type { ActionPreview as ActionPreviewType } from '../../types';

interface ActionPreviewProps {
  preview: ActionPreviewType;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function ActionPreview({
  preview,
  onConfirm,
  onCancel,
  isLoading = false,
}: ActionPreviewProps) {
  const { type, preview: data } = preview;

  const getTitle = () => {
    switch (type) {
      case 'sacuvaj_osobu':
        return 'Sačuvaj osobu';
      case 'azuriraj_osobu':
        return 'Ažuriraj osobu';
      case 'obrisi_osobu':
        return 'Obriši osobu';
      default:
        return 'Potvrdi akciju';
    }
  };

  const getDescription = () => {
    if (type === 'obrisi_osobu') {
      return `Da li želiš da obrišeš ${data.name}?`;
    }
    return `${data.name} - ${data.type_label || data.relationship_type}`;
  };

  const getVariantClass = () => {
    switch (type) {
      case 'sacuvaj_osobu':
        return 'save';
      case 'azuriraj_osobu':
        return 'update';
      case 'obrisi_osobu':
        return 'delete';
      default:
        return '';
    }
  };

  return (
    <div className={`action-preview ${getVariantClass()}`} data-testid="action-preview">
      <div className="action-preview-header">
        <strong>{getTitle()}</strong>
      </div>
      <div className="action-preview-content">
        <p>{getDescription()}</p>
        {data.birth_date && <p>Datum rođenja: {data.birth_date}</p>}
        {data.birth_place && <p>Mesto: {data.birth_place}</p>}
      </div>
      <div className="action-preview-buttons">
        <button
          data-testid="confirm-action"
          className="action-preview-btn confirm"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? 'Čuvam...' : 'Da, potvrđujem'}
        </button>
        <button
          data-testid="cancel-action"
          className="action-preview-btn cancel"
          onClick={onCancel}
          disabled={isLoading}
        >
          Otkaži
        </button>
      </div>
    </div>
  );
}

export default ActionPreview;
